module.exports = "<header-mov></header-mov>\n<div class=\"principal\" fxLayout=\"row\">\n    <text-editor-mov fxFlex=\"80%\"></text-editor-mov>\n</div>"